<template>
  <div class="pc-list" ref="list">
    <SeriesSearch @search="search" ref="reSearch" />

    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteLectureInit">删除</button>
          <span></span>
          <button @click="addLecture">添加</button>
          <span></span>
          <button @click="exportLecture">导出数据</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      :data="lectureList"
      @sort-change="changeSort"
      v-loading="loading"
    >
      <el-table-column width="100" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="id"
        label="编号"
        sortable="custom"
        width="100"
      ></el-table-column>
      <el-table-column label="缩放图" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.cover_image" class="eltable-img">
            <img :src="scope.row.cover_image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="课程名称" width="200" prop="chinese_title">
      </el-table-column>
      <el-table-column prop="scholar.chinese_name" label="讲师" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.scholar">
            {{
              scope.row.scholar.chinese_name
                ? scope.row.scholar.chinese_name
                : scope.row.scholar.english_name
            }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="series.chinese_name" label="课程系列" width="170">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.series" :key="index">
            {{ item.chinese_name }}
          </div>
        </template>
      </el-table-column> -->

      <el-table-column
        prop="nums"
        label="阅读数"
        sortable="custom"
        width="90"
      ></el-table-column>
      <el-table-column
        prop="score"
        label="评分"
        sortable="custom"
        width="80"
      ></el-table-column>
      <el-table-column label="状态" width="170">
        <template slot-scope="scope">
          <!-- scope.row.status -->
          <el-switch
            v-model="scope.row.status"
            @change="changeStatus(scope.row)"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createTime"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.createTime).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" min-width="120">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      v-if="lectureList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />

    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="deleteLecture"
    />
  </div>
</template>



<script>
import DeleteHint from "../../../template/DeleteHint";
import Pagination from "../../../componentSet/Pagination";


import SeriesSearch from "./SeriesSearch";
import { 
  getLectureList_Api,
  deleteLectureList_Api,
  updateLecture_Api ,
  outputLecture_Api,

} from "@/apis/lecture.api";

export default {
  components: {
    SeriesSearch,
    Pagination,
    DeleteHint,
  },
  watch: {},
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page:1,
        total: 0,
        take:10,
      },
      isSelectAll: false,
      lectureList: [],
      checked: [],
    };
  },
  
  mounted() {
    this.searchRules.series_id = Number(this.$route.query.id)
    this.getLectureListByRules(this.searchRules);
  },
  methods: {
    getLectureListByRules(data) {
      this.loading = true;
      getLectureList_Api(data).then((res) => {
        this.$set(this.pagination_options, "total", res.count);
        res.data.forEach((el) => {
          el.isSelect = false;
        });
        this.lectureList = res.data;
        this.loading = false;
        this.$global.success(this, "获取成功", null);
      });
    },
     changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getLectureListByRules(data);
      this.pagination_options.page = 1;
    },
    search(formData) {
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules, data);
      this.getLectureListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.title_keywords && formData.title_keywords[0]) {
        data.title_keywords = formData.title_keywords;
      }
      if (formData.tags_keywords && formData.tags_keywords.length > 0) {
        data.tags_keywords = [...formData.tags_keywords];
      }
      if (formData.id) {
        data.id = parseInt(formData.id);
      }
      if (formData.series_id) {
        data.series_id = parseInt(formData.series_id);
      }
      if (formData.scholar_id) {
        data.scholar_id = parseInt(formData.scholar_id);
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }  
      return data;
    },
    deleteLectureInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的项目！", null);
      }
    },
    addLecture() {
      let route = this.$router.resolve({
        path: "/admin/lecturedetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },
    exportLecture() {
      if (this.checked.length > 0) {
        outputLecture_Api({ lecture_id: this.checked }).then((res) => {
          this.$global.downloadFile(res, "lectureList");
        });
      } else {
        this.$global.error(this, "请先勾选要删除的项目！", null);
      }
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/lecturedetail",
        query: { id: item.id,method:'update' },
      });
      window.open(route.href, "_blank");
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.lectureList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.lectureList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
      console.log(this.checked);
    },
    changeStatus(row) {
      updateLecture_Api({ lecture_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    deleteLecture() {
      let delete_ids = { lecture_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteLectureList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getLectureListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getLectureListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/lecture/components/SeriesTable.vue